import React from 'react';
import { Row, Col, Typography, Result } from 'antd';
import { UnorderedListOutlined, RobotOutlined, AuditOutlined, SyncOutlined, AudioOutlined, ToolOutlined, LinkOutlined } from '@ant-design/icons';
import FunctionalityCard from '../components/Home/FunctionalityCard';
import { usePermissions } from '../contexts/PermissionContext';

const { Title } = Typography;

const HomePage: React.FC = () => {
  const { hasPermission, permissions } = usePermissions();

  // Sin ningún permiso útil
  if (!hasPermission('GCvsc.Menu.Read') && permissions.length === 0) {
    return (
      <Result
        status="403"
        title="Sin acceso"
        subTitle="Tu usuario no tiene permisos asignados en GCvsc. Contacta con Sistemas si crees que es un error."
      />
    );
  }

  // Modo completo con menú → panel de control con tarjetas filtradas por permisos
  return (
    <div>
      <Title level={2} style={{ marginBottom: '24px' }}>
        Panel de Control
      </Title>
      <Row gutter={[24, 24]}>
        {hasPermission('GCvsc.Transmisiones.Read') && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <FunctionalityCard
              title="Listado Gestión Transmisiones"
              icon={<UnorderedListOutlined />}
              path="/transmisiones"
              description="Gestión y seguimiento de transmisiones"
            />
          </Col>
        )}
        {hasPermission('GCvsc.Reconciliacion.Read') && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <FunctionalityCard
              title="Conciliación datos oficiales"
              icon={<AuditOutlined />}
              path="/reconciliacion"
              description="Conciliación CU2-Gescom"
            />
          </Col>
        )}
        {hasPermission('GCvsc.Reconciliacion.Read') && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <FunctionalityCard
              title="Vinculación CU2"
              icon={<LinkOutlined />}
              path="/vinculacion-cu2"
              description="Panel de vinculación CU2-Gescom"
            />
          </Col>
        )}
        {hasPermission('GCvsc.MejoraCU2.Read') && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <FunctionalityCard
              title="Mejora CU2"
              icon={<ToolOutlined />}
              path="/mejora-cu2"
              description="Gestión de casos GDO con Smartup"
            />
          </Col>
        )}
        {hasPermission('GCvsc.BrevoSync.Read') && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <FunctionalityCard
              title="Sincronización Brevo"
              icon={<SyncOutlined />}
              path="/brevo-sync"
              description="Sincronización de contactos con Brevo"
            />
          </Col>
        )}
        {hasPermission('GCvsc.KardioChat.Read') && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <FunctionalityCard
              title="KardioChat"
              icon={<RobotOutlined />}
              path="/chat"
              description="Asistente de IA para asesoramiento comercial"
            />
          </Col>
        )}
        {hasPermission('GCvsc.Agente.Read') && (
          <Col xs={24} sm={12} md={8} lg={6}>
            <FunctionalityCard
              title="Registro agente"
              icon={<AudioOutlined />}
              path="/agent"
              description="Registro de actividad del agente comercial"
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default HomePage;
